import { FormControl, MenuItem, Select } from "@mui/material";
import React, { Fragment, useEffect, useRef, useState } from "react";
import {
  fetchAddProductToCart,
  fetchProductsDetail,
  fetchRelatedProduct,
} from "../actions/global";

import ContactFooter from "../components/ContactFooter";
import NumberInput from "../components/Reusable/NumberInput";
import ReCAPTCHA from "react-google-recaptcha";
import RelatedProducts from "../components/RelatedProductsSection";
import { SlideshowLightbox } from "lightbox.js-react";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import { formattedPrice } from "../utils";
import i18next from "i18next";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import HelmetSeo from "../components/Reusable/HelmetSeo";
import { formatSizeLabel } from "../utils/cellRenderTable";
import { Spinner } from "react-bootstrap";

const ProductDetail = () => {
  const { id } = useParams();
  const { t } = useTranslation();
  const recaptchaRef = useRef();

  const [grindingOptions, setGrindingOptions] = useState([]);

  const navigate = useNavigate();

  const key = "6LeUftEoAAAAAGV2wD_uDEKaIrwHMZFw7sKDgkC9"; //localhost
  // const key = "6Le7BJYqAAAAALM_373PjAu7CYNDr_-Gq9L85ia7"; //fuka.rs

  const dispatch = useDispatch();
  const [activeLanguage, setActiveLanguage] = useState(i18next.language);
  const {
    dataProductDetailList,
    dataCartInfo,
    dataRelatedProductsList,
    loadingProductDetail,
  } = useSelector((state) => state.globalReducer);

  // useEffect(() => {
  //   if (!loadingProductDetail && dataProductDetailList === null) {
  //     navigate("/", { replace: true });
  //   }
  // }, [loadingProductDetail, dataProductDetailList, navigate]);

  const [sizeProduct, setSizeProduct] = useState({});
  const [grindLevel, setGrindLevel] = useState("WHOLE_BEANS");
  const [grindingProduct, setGrindingProduct] = useState({});
  const [qtyValue, setQtyValue] = useState(1);
  const [activeImage, setActiveImage] = useState("");

  const allImages = React.useMemo(() => {
    const main = dataProductDetailList?.imageFile
      ? [dataProductDetailList.imageFile]
      : [];
    const extra = Array.isArray(dataProductDetailList?.images)
      ? dataProductDetailList.images
      : [];

    // ukloni prazne + duplikate
    return Array.from(new Set([...main, ...extra].filter(Boolean)));
  }, [dataProductDetailList?.imageFile, dataProductDetailList?.images]);

  useEffect(() => {
    if (allImages.length) {
      setActiveImage(allImages[0]);
    } else {
      setActiveImage("");
    }
  }, [allImages]);

  useEffect(() => {
    dispatch(fetchProductsDetail(id, activeLanguage));
    // dispatch(fetchRelatedProduct(id));
  }, [dispatch, id]);

  // Inicijalizacija reCAPTCHA
  useEffect(() => {
    if (recaptchaRef?.current) {
      recaptchaRef.current.execute();
    }
  }, []);

  const heroData = {
    title: dataProductDetailList?.name,
  };

  useEffect(() => {
    // Funkcija koja se pokreće kada se promeni jezik
    const handleLanguageChange = (lng) => {
      dispatch(fetchProductsDetail(id, lng));
    };

    // Dodavanje event listener-a za promenu jezika
    i18next.on("languageChanged", handleLanguageChange);

    // Čišćenje event listener-a kada se komponenta unmount-uje
    return () => {
      i18next.off("languageChanged", handleLanguageChange);
    };
  }, [dispatch, id]);

  useEffect(() => {
    if (!dataProductDetailList) return;

    const options = [];

    if (dataProductDetailList.espresso) {
      options.push({
        id: 1,
        value: "espresso",
        label: "Espresso",
      });
    }

    if (dataProductDetailList.filtered) {
      options.push({
        id: 2,
        value: "filtered",
        label: "Filter",
      });
    }

    setGrindingOptions(options);

    // default selekcija
    if (options.length > 0) {
      setGrindingProduct(options[0]);
    } else {
      setGrindingProduct({});
    }

    // size default
    const selectedProductSize = dataProductDetailList?.details?.[0];
    if (selectedProductSize) {
      setSizeProduct(selectedProductSize);
    }
  }, [dataProductDetailList]);

  const handleAddToCart = async (event) => {
    event.preventDefault();

    // Pokreće reCAPTCHA za akciju "submit"
    // const token = await recaptchaRef.current.executeAsync("submit");

    // if (!token) {
    //   toast.error("Problem sa verifikacijom, osvezite stranicu.");
    //   return;
    // }

    const cartItemDetail = {
      quantity: qtyValue,
      coffeeType: grindLevel,
      productId: sizeProduct?.id,

      ...(dataProductDetailList?.type == "COFFEE" && {
        frying: grindingProduct?.value,
      }),
    };

    dispatch(fetchAddProductToCart(cartItemDetail, t));
  };

  const handleChangeQty = (event, value) => {
    event.preventDefault();
    setQtyValue(value);
  };
  // console.log(sizeProduct?.size, "sizeProduct?.size");

  return (
    <div className="product-detail-holder-content">
      <HelmetSeo
        title={"Fuka | " + dataProductDetailList?.locales?.[0]?.name}
        description={dataProductDetailList?.locales?.[0]?.description}
      />
      <div className="container">
        {/* <div className="product-detail-hero-holder">
          <Hero data={heroData} />
        </div> */}

        {/* OVERLAY LOADER dok se učitava proizvod */}
        {/* {loadingProductDetail && (
          <div className="product-detail-loading-overlay">
            <div className="product-detail-loading-box">
              <Spinner animation="border" role="status" />
              <div className="product-detail-loading-text">
                Učitavam proizvod...
              </div>
            </div>
          </div>
        )} */}

        <form onSubmit={handleAddToCart}>
          <div className="product-detail-content-main">
            <div className="product-detail-information">
              <div className="product-detail-image-holder">
                {allImages.length > 1 && (
                  <div className="product-detail-images-list">
                    {allImages.map((img, idx) => (
                      <img
                        key={`${img}-${idx}`}
                        src={img}
                        className={`img-fluid thumb ${
                          img === activeImage ? "active" : ""
                        }`}
                        alt="Fuka"
                        onClick={() => setActiveImage(img)}
                      />
                    ))}
                  </div>
                )}

                {/* MAIN PREVIEW */}
                <div className="product-detail-image-main-image">
                  {activeImage && (
                    <img
                      src={activeImage}
                      className="img-fluid main"
                      alt="Fuka"
                      onClick={() =>
                        document
                          .getElementById("hidden-lightbox-trigger")
                          ?.click()
                      }
                    />
                  )}

                  {/* HIDDEN LIGHTBOX GALLERY */}
                  {allImages.length > 0 && (
                    <div style={{ display: "none" }}>
                      <SlideshowLightbox showThumbnails={true}>
                        {allImages.map((img, idx) => (
                          <img
                            key={`lightbox-${idx}`}
                            src={img}
                            alt="Fuka"
                            id={
                              idx === 0 ? "hidden-lightbox-trigger" : undefined
                            }
                          />
                        ))}
                      </SlideshowLightbox>
                    </div>
                  )}
                </div>
              </div>
              <div className="product-detail-text-holder">
                <h1>{dataProductDetailList?.locales?.[0]?.name}</h1>
                <div className="product-detail-short-description">
                  <h5
                    dangerouslySetInnerHTML={{
                      __html:
                        dataProductDetailList?.locales?.[0]?.shortDescription,
                    }}
                  ></h5>
                </div>
                {dataProductDetailList?.type != "EQUIPMENT" && (
                  <div className="product-detail-size-holder">
                    <div className="product-detail-section-title">
                      {t("cart_view.size")}
                    </div>
                    <div className="product-detail-size-items">
                      {dataProductDetailList?.details?.map((item) => (
                        <div
                          key={item.id}
                          className={`product-detail-size-item ${
                            item.id == sizeProduct.id ? "active" : ""
                          }`}
                          onClick={() => setSizeProduct(item)}
                        >
                          {formatSizeLabel(item?.size)}
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {dataProductDetailList?.type == "COFFEE" &&
                  sizeProduct?.size != "BOX" && (
                    <Fragment>
                      {dataProductDetailList?.espresso &&
                        grindingOptions?.length > 0 && (
                          <div className="product-detail-grinding-holder">
                            <div className="product-detail-section-title">
                              {t("cart_view.roast")}
                            </div>
                            <div className="product-detail-grinding-items">
                              {grindingOptions?.map((item) => (
                                <div
                                  key={item.id} // Dodaj jedinstveni ključ
                                  className={`product-detail-grinding-item ${
                                    item.id == grindingProduct?.id
                                      ? "active"
                                      : ""
                                  }`}
                                  onClick={() => setGrindingProduct(item)}
                                >
                                  {item.label}
                                </div>
                              ))}
                            </div>
                          </div>
                        )}

                      {dataProductDetailList?.filtered && (
                        <div className="product-detail-grinding-holder">
                          <div className="product-detail-section-title">
                            {t("cart_view.level")}
                          </div>
                          <div className="product-detail-grinding-items">
                            <FormControl fullWidth size="small" required>
                              <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={grindLevel}
                                onChange={(event) =>
                                  setGrindLevel(event.target.value)
                                }
                                size="small"
                              >
                                <MenuItem value="WHOLE_BEANS">
                                  Whole beans
                                </MenuItem>
                                <MenuItem value="ESPRESSO_MACHINE">
                                  Espresso Machine
                                </MenuItem>
                                <MenuItem value="MOKA_POT">Moka Pot</MenuItem>
                                <MenuItem value="AEROPRESS">Aeropress</MenuItem>
                                <MenuItem value="V60">V60</MenuItem>
                                <MenuItem value="FRENCH_PRESS">
                                  French Press
                                </MenuItem>
                                <MenuItem value="CHEMEX">Chemex</MenuItem>
                                <MenuItem value="AUTOMATIC_FILTER_MACHINE">
                                  Automatic Filter Machine
                                </MenuItem>
                                <MenuItem value="TURKISH">Turkish</MenuItem>
                              </Select>
                            </FormControl>
                          </div>
                        </div>
                      )}
                    </Fragment>
                  )}

                <div className="product-detail-price-holder">
                  <div className="product-detail-section-title">
                    {t("cart_view.table_price")}
                  </div>
                  <div className="product-detail-price-item">
                    <div className="product-detail-price">
                      {sizeProduct?.discount ? (
                        <Fragment>
                          <div className="new-price">
                            {formattedPrice(sizeProduct?.discountPrice)} RSD
                          </div>
                          <div className="old-price">
                            {formattedPrice(sizeProduct?.price)} RSD
                          </div>
                        </Fragment>
                      ) : (
                        <div className="new-price">
                          {formattedPrice(sizeProduct?.price)} RSD
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="product-detail-quantity-holder">
                  <div className="product-detail-quantity-content" >
                    <div className="product-detail-quantity-input">
                      <NumberInput
                        max={sizeProduct?.quantity || 10}
                        handleChangeQty={handleChangeQty}
                      />
                    </div>
                    <div className="product-detail-quantity-button">
                      <button className="add-to-cart-button">
                        {t("other.add_to_cart")}
                      </button>
                    </div>
                  </div>
                  <p>* {t("other.free_delivery")}</p>
                </div>
              </div>
            </div>
            {dataProductDetailList?.locales?.[0]?.description && (
              <div className="product-detail-more">
                <div className="product-detail-more-list">
                  <div className="prodcut-detail-more-item active">
                    {t("other.productDesc")}
                  </div>
                  {/* <div className="prodcut-detail-more-item">
              Additional Information
            </div> */}
                </div>
                <div
                  className="product-detail-more-body"
                  dangerouslySetInnerHTML={{
                    __html: dataProductDetailList?.locales?.[0]?.description,
                  }}
                ></div>
              </div>
            )}
          </div>
          {/* <ReCAPTCHA sitekey={key} size="invisible" ref={recaptchaRef} /> */}
        </form>

        <RelatedProducts items={dataProductDetailList?.similarProducts} />
        <ContactFooter />
      </div>
    </div>
  );
};

export default ProductDetail;
